<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex>
        <v-layout align-center justify-center column pb-2>
          <router-link to="/register" class="button">
            <!-- <button to="/register" class="button"> -->
            Register for free
            <!-- </button> -->
          </router-link>
        </v-layout>

        <v-layout align-start justify-start column>
          <!-- Features banner could go here -->
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import availableFeatures from '@/config/benefits.js'

export default {
  name: "HomeRegister",

  data: () => ({
    features: availableFeatures
  })
};
</script>

<style lang="scss" scoped>
.features {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-items: flex-start;
    margin: 40px auto 0;
    padding: 0;
    max-width: 1200px;
    list-style: none;
    color: $primary-club;

    &__item {
      flex-grow: 1;
      flex-basis: 0;
      margin: 0 10px 30px;
      font-size: 15px;
      font-style: normal;
      font-weight: normal;
      line-height: 1.47;
      text-align: center;
      white-space: nowrap;
      color: $primary-club;

      span {
        display: block;
      }

      &:before {
        content: '';
        display: block;
        margin: 0 auto 10px;
        height: 97px;
        width: 97px;
        background-color: rgba(255, 255, 255, 0.75);
        background-position: 50%;
        background-repeat: no-repeat;
        border: 2px solid #fff;
        border-radius: 50%;
      }

      &--clubtv:before {
        mask-image: url('../assets/sso-icon-set/sso-club-tv.svg');
        mask-repeat: no-repeat;
        mask-position: center;
        mask-size: 64px;
        background-color: $primary-club;
      }

      &--sso-app:before {
        mask-image: url('../assets/sso-icon-set/sso-app.svg');
        mask-repeat: no-repeat;
        mask-position: center;
        mask-size: 64px;
        background-color: $primary-club;
      }

      &--sso-auction-site:before {
        mask-image: url('../assets/sso-icon-set/sso-auction-site.svg');
        mask-repeat: no-repeat;
        mask-position: center;
        mask-size: 64px;
        background-color: $primary-club;
      }
      &--sso-club-site:before {
        mask-image: url('../assets/sso-icon-set/sso-club-site.svg');
        mask-repeat: no-repeat;
        mask-position: center;
        mask-size: 64px;
        background-color: $primary-club;
      }

      &--sso-click-collect:before {
        mask-image: url('../assets/sso-icon-set/sso-click-collect.svg');
       mask-repeat: no-repeat;
        mask-position: center;
        mask-size: 64px;
        background-color: $primary-club;
      }
      &--sso-memberships:before {
        mask-image: url('../assets/sso-icon-set/sso-memberships.svg');
        mask-repeat: no-repeat;
        mask-position: center;
        mask-size: 64px;
        background-color: $primary-club;
      }

      &--sso-rewards:before {
        mask-image: url('../assets/sso-icon-set/sso-rewards.svg');
        mask-repeat: no-repeat;
        mask-position: center;
        mask-size: 64px;
        background-color: $primary-club;
      }
      &--sso-ticketing:before {
        mask-image: url('../assets/sso-icon-set/sso-ticketing.svg');
        mask-repeat: no-repeat;
        mask-position: center;
        mask-size: 64px;
        background-color: $primary-club;
      }

      &--sso-official-store:before {
        mask-image: url('../assets/sso-icon-set/sso-official-store.svg');
        mask-repeat: no-repeat;
        mask-position: center;
        mask-size: 64px;
        background-color: $primary-club;
      }
    }
  }

</style>
